module.exports = __webpack_public_path__ + "static/media/slide-6.a3413bac.jpg";